import React from 'react';
import { Box, Grid2 } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CartLoader from '../../../Helper/Loaders/CartLoader';
import BaseChart from './BaseChart';
import TimeAxis from '../../DigitalTwinV3/Tabs/BatteryVitals/BinarySignals/TimeAxis';

const BinarySignalChart = ({
    isLoading,
    chartID = "chartID",
    binarySignalsData,
    batteryInfo = {},
    selectedEntity = null,
}) => {

    const { t } = useTranslation()

    if (isLoading) {
        return (
            <Box sx={{ height: 525, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <CartLoader />
            </Box>
        );
    }

    return (
        <Grid2 container>
            <Box sx={{ maxHeight: '400px', overflow: 'hidden', width: '100%' }}>
                <Box sx={{ height: '100%', overflowY: 'auto', overflowX: 'hidden', width: 'calc(100% - 16px)' }}>
                    <Grid2 container flexDirection={'column'} gap={1.5} py={2} flexWrap={'nowrap'} sx={{height: '100%', pl: 8, pr: 5.25}}>
                        {(Object.values(binarySignalsData) ?? []).map(signalData => {
                            return <BaseChart
                                key={Math.random()}
                                chartId={`binary-signal-chart-${signalData.title}`}
                                title={signalData.title}
                                segments={signalData.segments}
                                colors={signalData.colors}
                                batteryInfo={batteryInfo}
                                selectedEntity={selectedEntity}
                            />
                        })}
                    </Grid2>
                </Box>
            </Box>
            <Box sx={{
                width: '100%',
                pl: 8,
                pr: 7,
                // px: 10,
                mx: 'auto',
                my: 2,
            }}>
                <TimeAxis />
            </Box>
        </Grid2>
    );
};

export default BinarySignalChart;
